import { render } from "./PurchaseTableItem.vue?vue&type=template&id=28b14026&scoped=true&ts=true&lang=pug"
import script from "./PurchaseTableItem.vue?vue&type=script&lang=ts"
export * from "./PurchaseTableItem.vue?vue&type=script&lang=ts"

import "./PurchaseTableItem.vue?vue&type=style&index=0&id=28b14026&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b14026"]])

export default __exports__